{
  "level": "field9",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:field9",
    "objects": "AREAS.E3:field9.e3",
    "mesh": "TREES.E3:field9.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4370.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: field9",
      "entity_class": "CSlidingDoor",
      "piece_name": "field9",
      "offset": 437,
      "centroid": [
        909.5740203857422,
        738.3384017944336,
        94.96791362762451
      ],
      "bbox_min": [
        839.476318359375,
        640.0,
        60.0
      ],
      "bbox_max": [
        970.0,
        809.476318359375,
        140.0
      ],
      "dimensions_source": {
        "span_x": 130.523681640625,
        "span_y": 169.476318359375,
        "height_z": 80.0,
        "door_width": 169.476318359375,
        "door_depth": 130.523681640625,
        "leaf_depth": 130.483681640625,
        "clearance_margin": 0.02,
        "slide_axis": "z"
      },
      "vertices": [
        [
          970.0,
          707.730224609375,
          120.0
        ],
        [
          898.6452026367188,
          752.337646484375,
          140.0
        ],
        [
          898.6452026367188,
          752.337646484375,
          140.0
        ],
        [
          839.476318359375,
          809.476318359375,
          140.0
        ],
        [
          839.476318359375,
          809.476318359375,
          140.0
        ],
        [
          839.476318359375,
          809.476318359375,
          66.60848236083984
        ],
        [
          839.476318359375,
          809.476318359375,
          66.60848236083984
        ],
        [
          898.6452026367188,
          752.337646484375,
          85.9383773803711
        ],
        [
          898.6452026367188,
          752.337646484375,
          85.9383773803711
        ],
        [
          890.34912109375,
          760.3490600585938,
          66.70545196533203
        ],
        [
          890.34912109375,
          760.3490600585938,
          66.70545196533203
        ],
        [
          970.0,
          650.0,
          60.0
        ],
        [
          970.0,
          700.0,
          60.0
        ],
        [
          970.0,
          640.0,
          120.0
        ],
        [
          970.0,
          640.0,
          80.0
        ],
        [
          970.0,
          707.730224609375,
          80.98199462890625
        ]
      ]
    }
  ],
  "tutorial_messages": []
}